import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, TransitionGroup as _TransitionGroup, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "pin-message-wrapper"
}
const _hoisted_2 = { class: "pin-message" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "reply-to"
}
const _hoisted_5 = { class: "recipient-name" }
const _hoisted_6 = {
  key: 1,
  class: "reply-to"
}
const _hoisted_7 = { class: "recipient-name" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "chat-time" }
const _hoisted_10 = { class: "chat-sender-name" }
const _hoisted_11 = {
  key: 0,
  class: "chat-input-wrapper"
}
const _hoisted_12 = {
  key: 0,
  class: "to-reply-message"
}
const _hoisted_13 = { class: "to-reply__user-name" }
const _hoisted_14 = {
  key: 0,
  class: "to-reply__user-message"
}
const _hoisted_15 = { class: "close-place" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = { class: "btn-send-message" }
const _hoisted_18 = {
  key: 1,
  class: "chat-input-wrapper is-muted"
}

import simplebar from "simplebar-vue";
  import moment from "moment-timezone";
  import apiClient from "@/services/api";
  import CustomScrollbar from "@/components/_partials/CustomScrollbar.vue";
  import {
    BaseIcon,
    CloseIcon,
    KeepIcon,
    MicrophoneIcon,
    MicrophoneOffIcon,
    ReplyIcon,
    SendIcon
  } from "@/components/icons";
  import { computed, inject, nextTick, onMounted, reactive, ref, watch, watchEffect } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import { IMessage, IMessageData, IUser } from "@/models";
  import { MessageDirections } from "@/enum";
  import Preloader from "@/components/_partials/Preloader.vue";
  import { useToast } from "primevue/usetoast";
  import { trans } from "@/utils/trans";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Chat',
  props: {
    isVisible: { type: Boolean, default: false }
  },
  setup(__props: any) {

  const auctionStore = useAuctionStore();
  const user = computed(() => auctionStore.user);
  const observe = ref<HTMLDivElement>();
  const container = ref<typeof simplebar>();
  const messageInput = ref<HTMLInputElement>();
  const toast = useToast();
  const emitter = inject("emitter");

  const props = __props;

  const state = reactive({
    format: {
      date: "DD MMM YYYY",
      time: "HH:mm",
      dbDateFormat: "YYYY-MM-DDTHH:mm:ss.SSSSZ"
    },
    message: null as null | string,
    forUser: null as null | IUser,
    awaitFormServerResponse: false,
    chatMessages: [] as IMessage[],
    chatMessagesInfiniteLoaderEnabled: false,
    chatMessagesPreloaderShow: false,
    chatMessagesLastLoadedDate: null as null | string,
    chatMessagesLastLoadedId: null as null | number,
    chatMessagesIntersectionObserver: null as null | IntersectionObserver,
    pinMessage: null as null | IMessage,
    blinkMessages: [] as number[],
    clearBlinkMessagesTimerId: null as null | number,
    mutedUsers: [] as number[],
    awaitChangeMuteState: false
  });

  watchEffect(() => {
    if (observe.value && state.chatMessagesIntersectionObserver) {
      if (props.isVisible) {
        state.chatMessagesIntersectionObserver.observe(observe.value);
      } else {
        state.chatMessagesIntersectionObserver.unobserve(observe.value);
      }
    }
  });

  watch(
    () => props.isVisible,
    (nv) => {
      if (nv) {
        scrollToBottom();
      }
    }
  );

  watchEffect(() => {
    if (state.blinkMessages.length && auctionStore.pageIsActive && props.isVisible) {
      if (state.clearBlinkMessagesTimerId) {
        clearTimeout(state.clearBlinkMessagesTimerId);
      }
      state.clearBlinkMessagesTimerId = setTimeout(() => (state.blinkMessages = []), 10000);
    }
    if (auctionStore.hasNewChatMessage && props.isVisible && auctionStore.pageIsActive) {
      markRead();
    }
  });

  const reversedMessages = computed(() => {
    return [...(state.chatMessages || [])].reverse();
  });
  const inputPlaceholder = computed(() => {
    if (auctionStore.user?.is_admin) {
      return trans("live.common.chat.admin_message_placeholder");
    }
    return trans("live.common.chat.client_message_placeholder");
  });

  onMounted(async () => {
    state.chatMessagesLastLoadedDate = getNow();
    getMutedUsers();
    loadChatMessages(true, false);

    state.chatMessagesIntersectionObserver = new IntersectionObserver((entries) => {
      if (entries[0].intersectionRatio <= 0) return;

      if (state.chatMessagesInfiniteLoaderEnabled) {
        loadChatMessages(false, true);
      }
    });

    emitter?.on("on:ws-chat-new-message", handleNewMessage);
    emitter?.on("on:ws-chat-new-admin-message", handleNewAdminMessage);
    emitter?.on("on:ws-chat-pin-message", handlePinMessage);
  });

  const handleNewMessage = (data: { userId?: number; message: IMessageData }) => {
    state.chatMessages = [getMessageFromMessageData(data.message), ...state.chatMessages];
    hasNewMessage(data.message);
    scrollToBottom();
  };

  const handleNewAdminMessage = (data: { userId?: number; message: IMessageData }) => {
    const newMessage = getMessageFromMessageData(data.message);
    state.chatMessages = [newMessage, ...state.chatMessages];
    if (newMessage.direction === MessageDirections.DIRECTION_TO_USER && !newMessage.user?.id) {
      emitter?.emit("on:chat-new-message", newMessage);
    }
    hasNewMessage(data.message);
    scrollToBottom();
  };

  const handlePinMessage = (data: { message: IMessageData | null }) => {
    state.pinMessage = data.message ? getMessageFromMessageData(data.message) : null;
    auctionStore.$patch({
      pinMessage: state.pinMessage
    });
    if (data.message) {
      hasNewMessage(data.message);
    }
  };

  const onInitScroll = (scrollbar: typeof simplebar) => {
    container.value = scrollbar.value.scrollElement;
  };

  const onKey = (event: KeyboardEvent) => {
    if (event.key === "Enter") {
      event.preventDefault();
      send();
    }
  };

  const answerFor = (message: IMessage) => {
    state.forUser = message.user;
    state.forUser.message = message;
    messageInput.value?.focus();
  };

  const cancelAnswer = () => {
    state.forUser = null;
  };

  const loadChatMessages = (clear = false, loadMore = false, fromDate = "") => {
    if (!auctionStore.auction?.id) {
      return;
    }
    state.chatMessagesInfiniteLoaderEnabled = false;

    if (clear) {
      state.chatMessagesPreloaderShow = true;
      state.chatMessages = [];
    }

    let filter = {
      auction_id: auctionStore.auction.id,
      to_date: getNow(),
      limit: 50
    } as {
      auction_id: number;
      to_date?: string;
      from_date?: string;
      limit: number;
      not_id?: number | null;
    };

    if (loadMore) {
      state.chatMessagesPreloaderShow = true;

      if (state.chatMessagesLastLoadedDate) {
        filter.to_date = moment.utc(state.chatMessagesLastLoadedDate).format(state.format.dbDateFormat);
      }
      if (state.chatMessagesLastLoadedId) {
        filter.not_id = state.chatMessagesLastLoadedId;
      }
    }

    if (fromDate && fromDate.length > 0) {
      filter.from_date = moment.utc(fromDate).format(state.format.dbDateFormat);
      filter.limit = 1000;
    }

    apiClient.get(auctionStore.routes["live_chat.get"] + "?" + new URLSearchParams(filter)).then((response) => {
      const { messages, total, pin_message } = response.data;

      let prevContainerHeight = container.value?.scrollHeight;

      state.chatMessagesPreloaderShow = false;
      state.chatMessagesInfiniteLoaderEnabled = filter.limit < total;

      state.pinMessage = pin_message ? getMessageFromMessageData(pin_message) : null;

      auctionStore.$patch({
        pinMessage: state.pinMessage
      });

      messages.forEach((messageData: IMessageData) => {
        const message = getMessageFromMessageData(messageData);

        if (!messageData.is_read) {
          if (
            (user.value?.is_admin && messageData.direction == MessageDirections.DIRECTION_TO_ADMIN) ||
            (!user.value?.is_admin &&
              messageData.user_id &&
              messageData.direction == MessageDirections.DIRECTION_TO_USER)
          ) {
            auctionStore.$patch({
              hasNewChatMessage: true
            });
          }
        }

        if (moment.utc(message.createdAt).isBefore(moment.utc(state.chatMessagesLastLoadedDate))) {
          state.chatMessagesLastLoadedDate = moment(message.createdAt).format();
          state.chatMessagesLastLoadedId = messageData.id;
        }

        state.chatMessages.push(message);
      });

      nextTick(() => {
        if (container.value) {
          if (loadMore) {
            container.value.scrollTop = container.value.scrollHeight - prevContainerHeight;
          } else {
            scrollToBottom();
          }
        }
      });
    });
  };

  const getNow = () => {
    return moment.utc().format(state.format.dbDateFormat);
  };

  const scrollToBottom = () => {
    nextTick(() => {
      if (container.value) {
        container.value.scrollTop = container.value.scrollHeight;
      }
    });
  };

  const getMessageFromMessageData = (messageData: IMessageData): IMessage => {
    return {
      id: messageData.id,
      direction: messageData.direction,
      sender: messageData.direction === 2 ? messageData.sender || `Oldlouis Auctions` : messageData.user?.full_name,
      text: messageData.message,
      fileType: messageData.file?.file_type,
      filePath: messageData.file?.file_path,
      fileName: messageData.file?.file_name,
      is_pinned: messageData.is_pinned,
      createdAt: messageData.created_at,
      createdAtHumanized: moment(messageData.created_at).format(state.format.time),
      user: messageData.user
    };
  };

  const send = () => {
    if (state.awaitFormServerResponse || !user.value?.id || !auctionStore.auction?.id) {
      return;
    }

    if (!state.message?.length) {
      return;
    }

    if (state.forUser && !state.forUser.id) {
      toast.add({
        severity: "error",
        summary: trans("live.toast.error"),
        detail: trans("live.toast.unknown_error"),
        life: 6000
      });
    }

    const message = state.message;
    const userId = state.forUser?.id;
    state.message = null;
    state.forUser = null;
    state.awaitFormServerResponse = true;

    apiClient
      .post(auctionStore.routes["live_chat.store"], {
        auction_id: auctionStore.auction.id,
        user_id: userId,
        message
      })
      .then((response) => {
        if (!response.data.status) {
          toast.add({
            severity: "error",
            summary: trans("live.toast.error"),
            detail: response.data.message || trans("live.toast.unknown_error"),
            life: 6000
          });
        }
      })
      .catch(() => {
        state.message = message;
      })
      .finally(() => (state.awaitFormServerResponse = false));
  };

  const hasNewMessage = (message: IMessageData) => {
    if (
      (user.value?.is_admin && message.direction == MessageDirections.DIRECTION_TO_ADMIN) ||
      (!user.value?.is_admin && message.direction == MessageDirections.DIRECTION_TO_USER)
    ) {
      if (!auctionStore.pageIsActive || !props.isVisible) {
        const newMessages = state.blinkMessages;
        newMessages.push(message.id);
        state.blinkMessages = [];
        nextTick(() => {
          state.blinkMessages = newMessages;
        });
      }
      auctionStore.hasNewChatMessage = true;
    }
  };
  const onPinMessage = (message: IMessage) => {
    if (!user.value?.id || !user.value?.is_admin || !auctionStore.auction?.id) {
      return;
    }

    apiClient
      .post(auctionStore.routes["live_chat.pin"], {
        auction_id: auctionStore.auction.id,
        message_id: message.id
      })
      .then(() => {
        state.chatMessages.forEach((item) => {
          item.is_pinned = false;
        });
        message.is_pinned = true;
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => (state.awaitFormServerResponse = false));
  };

  const markRead = () => {
    if (!user.value?.id || !auctionStore.auction?.id) {
      return;
    }

    apiClient
      .put(auctionStore.routes["live.chat.mark_read"], {
        auctionId: auctionStore.auction.id
      })
      .then(() => {
        state.chatMessages.forEach((message) => {
          message.is_read = true;
        });

        auctionStore.$patch({
          hasNewChatMessage: false
        });
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getMutedUsers = () => {
    if (!user.value?.is_admin) {
      return;
    }

    apiClient
      .get(auctionStore.routes["live.users.get_muted_users"])
      .then((response) => {
        state.mutedUsers = response.data;
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const muteUser = (user: IUser) => {
    updateUserMute(user, auctionStore.routes["live.users.mute"]);
  };
  const unMuteUser = (user: IUser) => {
    updateUserMute(user, auctionStore.routes["live.users.unmute"]);
  };

  const updateUserMute = (user: IUser, href: string) => {
    if (state.awaitChangeMuteState) {
      return;
    }

    state.awaitChangeMuteState = true;
    apiClient
      .put(href, { userId: user.id })
      .then((response) => {
        if (response.data.status) {
          if (response.data.customer_is_muted) {
            state.mutedUsers.push(user.id);
          } else {
            state.mutedUsers = state.mutedUsers.filter((id: number) => {
              return id !== user.id;
            });
          }

          auctionStore.$patch((storeState) => {
            if (storeState.userData[user.id]) {
              storeState.userData[user.id].customer_is_muted = response.data.customer_is_muted;
            }
            const index = auctionStore.activeLot.bidders.findIndex((item) => {
              return item.id === user.id;
            });
            if (index >= 0) {
              storeState.activeLot.bidders[index].customer_is_muted = response.data.customer_is_muted;
            }
          });
        }
        toast.add({
          severity: response.data.status ? "success" : "error",
          summary: trans("live.toast." + (response.data.status ? "success" : "error")),
          detail: response.data.message || trans("live.toast.unknown_error"),
          life: 6000
        });
      })
      .finally(() => (state.awaitChangeMuteState = false));
  };

  emitter.on("on:user-message", (data: IUser) => {
    state.forUser = {
      id: data.id,
      full_name: data.full_name
    } as IUser;
  });

  emitter.on("on:user-mute", (data: { userId: number; customerIsMuted: boolean }) => {
    if (data.customerIsMuted) {
      state.mutedUsers.push(data.userId);
    } else {
      state.mutedUsers = state.mutedUsers.filter((id: number) => {
        return id !== data.userId;
      });
    }
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'chat',
      { seller: user.value?.is_admin },
      { 'is-reply': user.value?.is_admin && state.forUser?.id },
      { 'pinned-message': state.pinMessage?.id }
    ])
  }, [
    _createVNode(CustomScrollbar, {
      class: _normalizeClass(["custom-scrollbar messages-wrapper controller-scrollbar", { 'no-auth': !user.value?.id }]),
      onScrollerComponent: onInitScroll
    }, {
      default: _withCtx(() => [
        (state.chatMessagesPreloaderShow)
          ? (_openBlock(), _createBlock(Preloader, {
              key: 0,
              class: "chat"
            }))
          : _createCommentVNode("", true),
        (state.chatMessagesInfiniteLoaderEnabled)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "observe",
              ref_key: "observe",
              ref: observe
            }, null, 512))
          : _createCommentVNode("", true),
        (state.pinMessage?.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(BaseIcon), {
                  class: "keep",
                  "icon-name": "keep",
                  width: "20",
                  height: "20",
                  "view-box": "0 -960 960 960",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (onPinMessage(state.pinMessage)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(KeepIcon))
                  ]),
                  _: 1
                }),
                _createElementVNode("div", {
                  class: "chat-message",
                  innerHTML: state.pinMessage.text
                }, null, 8, _hoisted_3)
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_TransitionGroup, { name: "messages" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reversedMessages.value, (message) => {
              return (_openBlock(), _createElementBlock("div", {
                key: message.id,
                class: _normalizeClass([
            'chat-message-wrapper',
            {
              'auctioneer-message': message.direction === _unref(MessageDirections).DIRECTION_TO_USER,
              'reply-message': user.value?.is_admin && message.user?.id
            }
          ])
              }, [
                (user.value?.is_admin && message.direction === _unref(MessageDirections).DIRECTION_TO_USER && !message.user?.id)
                  ? (_openBlock(), _createBlock(_unref(BaseIcon), {
                      key: 0,
                      class: _normalizeClass(['keep', { pinned: message.is_pinned }]),
                      "icon-name": "keep",
                      width: "20",
                      height: "20",
                      "view-box": "0 -960 960 960",
                      onClick: ($event: any) => (onPinMessage(message))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(KeepIcon))
                      ]),
                      _: 2
                    }, 1032, ["class", "onClick"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: _normalizeClass(["chat-message", {
              reply: user.value?.is_admin && message.user?.id,
              highlighted: state.blinkMessages.includes(message.id)
            }])
                }, [
                  (user.value?.is_admin && message.user?.id && message.direction === _unref(MessageDirections).DIRECTION_TO_USER)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(trans)("live.common.chat.answer_to", { user: message.user.full_name })), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!user.value?.is_admin && message.user?.id && message.direction === _unref(MessageDirections).DIRECTION_TO_USER)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(trans)("live.common.chat.private_message")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    innerHTML: message.text
                  }, null, 8, _hoisted_8),
                  (user.value?.is_admin && message.direction === _unref(MessageDirections).DIRECTION_TO_ADMIN)
                    ? (_openBlock(), _createBlock(_unref(BaseIcon), {
                        key: 2,
                        class: "icon-reply",
                        "icon-name": "reply",
                        width: "18",
                        height: "15",
                        "view-box": "0 0 18 15",
                        onClick: ($event: any) => (answerFor(message))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ReplyIcon))
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_9, [
                    _createElementVNode("span", null, _toDisplayString(message.createdAtHumanized), 1)
                  ])
                ], 2),
                _createElementVNode("div", _hoisted_10, [
                  _createTextVNode(_toDisplayString(message.sender) + " ", 1),
                  (user.value?.is_admin && message.direction === _unref(MessageDirections).DIRECTION_TO_ADMIN)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (state.mutedUsers.includes(message.user.id))
                          ? (_openBlock(), _createBlock(_unref(BaseIcon), {
                              key: 0,
                              class: "icon-microphone-off",
                              "icon-name": "microphone-off",
                              width: "15.158",
                              height: "16",
                              "view-box": "0 0 15.158 16",
                              onClick: ($event: any) => (unMuteUser(message.user))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(MicrophoneOffIcon))
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : (_openBlock(), _createBlock(_unref(BaseIcon), {
                              key: 1,
                              class: "icon-microphone",
                              "icon-name": "microphone",
                              width: "11.79",
                              height: "16",
                              "view-box": "0 0 11.79 16",
                              onClick: ($event: any) => (muteUser(message.user))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(MicrophoneIcon))
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ], 2))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["class"]),
    (user.value?.id && !user.value.customer_is_muted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (user.value.is_admin && state.forUser?.id)
            ? (_openBlock(), _createElementBlock("label", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(trans)("live.common.chat.answer_to", { user: state.forUser?.full_name })), 1),
                (state.forUser.message)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(state.forUser.message.text), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_15, [
                  _createVNode(_unref(BaseIcon), {
                    class: "icon-close",
                    "icon-name": "close",
                    width: "12",
                    height: "12",
                    viewBox: "0 0 26.87 26.87",
                    onClick: cancelAnswer
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CloseIcon))
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("input", {
            class: "chat-input-field",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.message) = $event)),
            type: "text",
            placeholder: inputPlaceholder.value,
            required: "",
            onKeyup: _withModifiers(onKey, ["stop"]),
            onKeydown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
            ref_key: "messageInput",
            ref: messageInput
          }, null, 40, _hoisted_16), [
            [_vModelText, state.message]
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_unref(BaseIcon), {
              "icon-name": "send",
              onClick: send
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(SendIcon))
              ]),
              _: 1
            })
          ])
        ]))
      : (user.value?.id && user.value.customer_is_muted)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(trans)("live.common.chat.messaging_disabled")), 1))
        : _createCommentVNode("", true)
  ], 2))
}
}

})